module.exports = __webpack_public_path__ + "static/img/WechatIMG123.8561045.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/explain/WechatIMG123.jpeg
// module id = 909
// module chunks = 0